import { CoinResponse } from "baaanggg";
import { resolveImageUrl } from "@helpers/image.helper";

type Props = {
    coin: CoinResponse,
    isSelected: boolean
}

export function CoinDropdownItem({ coin, isSelected }: Props) {
    return <span className="flex items-center space-x-3">
        <img src={resolveImageUrl(coin.icon ?? "/src/img/coins/gold.svg")} className="h-6 w-6 rounded-full" loading="lazy"
            alt="avatar" />
        <span className={`${isSelected ? 'text-jacarta-500' : 'text-white'}`}>{coin.name}</span>
    </span>
}